import { render } from "./HeroiconsOutlineCalendar.vue?vue&type=template&id=6d2344d7"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCalendar.vue"]])

export default __exports__